import { render, staticRenderFns } from "./couponcoll.vue?vue&type=template&id=ecd89b20&scoped=true"
import script from "./couponcoll.vue?vue&type=script&lang=js"
export * from "./couponcoll.vue?vue&type=script&lang=js"
import style0 from "./couponcoll.vue?vue&type=style&index=0&id=ecd89b20&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd89b20",
  null
  
)

export default component.exports